import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CategorieService } from '../../../../services/categorie-unite-marque/categorie.service';
import { UniteService } from '../../../../services/categorie-unite-marque/unite.service';
import { MarqueService } from '../../../../services/categorie-unite-marque/marque.service';
import { Categorie } from '../../../../models/categorie';
import { Unite } from '../../../../models/unite';
import { Marque } from '../../../../models/marque';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
    selector: 'app-croud-marque-category',
    templateUrl: './croud-marque-category.component.html',
    styleUrls: ['./croud-marque-category.component.scss']
})
export class CroudMarqueCategoryComponent {
    @Input() modalTitle: string = '';
    @Input() modalSubType: string = '';
    @Input() idStation: number = 0;
    @Input() existingData: Categorie | Unite | Marque | any = null;
    @Input() isEditMode: boolean = false;
    code = '';
    restriction = 'achat_et_vente';
    currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    clientId = this.currentUser?.id || 0;
    stationId = this.currentUser?.stations?.[0]?.id || this.idStation;

    constructor(
        public activeModal: NgbActiveModal,
        private categorieService: CategorieService,
        private uniteService: UniteService,
        private marqueService: MarqueService,
        private toastr: ToastrService,
        private router: Router,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        if (this.isEditMode && this.existingData) {
            this.populateForm();
        }
    }

    populateForm(): void {
        if (this.modalSubType === 'catégorie') {
            this.code = this.existingData.libelle || '';
            this.restriction = this.existingData.restriction || 'achat_et_vente';
        } else if (this.modalSubType === 'unité' || this.modalSubType === 'marque') {
            this.code = this.existingData.libelle || '';
        }
    }

    resetForm() {
        this.code = '';
        this.restriction = 'achat_et_vente';
    }

    save() {
        if (!this.clientId) {
            this.toastr.error('Utilisateur non connecté.', 'Erreur');
            this.router.navigate(['/pages/authentication/login-v2']);
            this.activeModal.dismiss('Utilisateur non connecté');
            return;
        }

        if (!this.stationId) {
            this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
            this.router.navigate(['/create-station']);
            this.activeModal.dismiss('Aucune station sélectionnée');
            return;
        }

        if (!this.code.trim()) {
            this.toastr.error('Le libellé est requis.', 'Erreur');
            this.activeModal.dismiss('Le libellé est requis');
            return;
        }

        if (this.modalSubType === 'catégorie') {
            const categorie: Categorie = {
                id: this.isEditMode ? this.existingData?.id || 0 : 0,
                user_id: this.clientId,
                station_id: this.stationId,
                libelle: this.code,

            };
            const action = this.isEditMode ? this.categorieService.updateCategorie(categorie, this.stationId) : this.categorieService.addCategorie(categorie);
            action.subscribe({
                next: (result: Categorie) => {
                   // console.log(this.isEditMode ? 'Updated category:' : 'Received new category:', result);
                    this.toastr.success(this.isEditMode ? 'Catégorie mise à jour !' : 'Catégorie ajoutée avec succès !', 'Succès');
                    this.activeModal.close(result);
                    this.cdr.detectChanges();
                },
                error: (error) => {
                   // console.error('Save error:', error);
                    this.toastr.error(error.message || 'Erreur lors de l\'enregistrement de la catégorie.', 'Erreur');
                    this.activeModal.dismiss('Erreur lors de l\'enregistrement');
                }
            });
        } else if (this.modalSubType === 'unité') {
            const unite: Unite = {
                id: this.isEditMode ? this.existingData?.id || 0 : 0,
                user_id: this.clientId,
                station_id: this.stationId,
                libelle: this.code
            };
            const action = this.isEditMode ? this.uniteService.updateUnite(unite, this.stationId) : this.uniteService.addUnite(unite);
            action.subscribe({
                next: (result: Unite) => {
                   // console.log(this.isEditMode ? 'Updated unit:' : 'Received new unit:', result);
                    this.toastr.success(this.isEditMode ? 'Unité mise à jour !' : 'Unité ajoutée avec succès !', 'Succès');
                    this.activeModal.close(result);
                    this.cdr.detectChanges();
                },
                error: (error) => {
                   // console.error('Save error:', error);
                    this.toastr.error(error.message || 'Erreur lors de l\'enregistrement de l\'unité.', 'Erreur');
                    this.activeModal.dismiss('Erreur lors de l\'enregistrement');
                }
            });
        } else if (this.modalSubType === 'marque') {
            const marque: Marque = {
                id: this.isEditMode ? this.existingData?.id || 0 : 0,
                user_id: this.clientId,
                station_id: this.stationId,
                libelle: this.code
            };
            const action = this.isEditMode ? this.marqueService.updateMarque(marque, this.stationId) : this.marqueService.addMarque(marque);
            action.subscribe({
                next: (result: Marque) => {
                   // console.log(this.isEditMode ? 'Updated marque:' : 'Received new marque:', result);
                    this.toastr.success(this.isEditMode ? 'Marque mise à jour !' : 'Marque ajoutée avec succès !', 'Succès');
                    this.activeModal.close(result);
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    //console.error('Save error:', error);
                    this.toastr.error(error.message || 'Erreur lors de l\'enregistrement de la marque.', 'Erreur');
                    this.activeModal.dismiss('Erreur lors de l\'enregistrement');
                }
            });
        }
    }

    closeModal() {
        this.activeModal.dismiss('Close clicked');
    }
}
